module.exports = __webpack_public_path__ + "ios-preview.ed5740e561aa27c7db71.png";


//////////////////
// WEBPACK FOOTER
// /ng-app/src/assets/images/ios-preview.png
// module id = ../../../../../src/assets/images/ios-preview.png
// module chunks = main